// export const apiEndpoint = 'https://api.the.lht-jsc.com.vn/api';
// nginx serves the API under /api on the same address as the page, so the app works over both
// http and https and the browser never needs port 9090. `yarn dev` talks to a local backend.
export const apiEndpoint =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:9090/api'
    : `${window.location.origin}/api`;
